import {
    takeEvery, all, put, call,
} from 'redux-saga/effects';
import API from '../common/API';
import * as Actions from '../actions/OuterServerMail';
import { waitAuthorizedCheck } from './Auth';

function* getOuterServerMail(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const endpoint = `/api/v1/event/${action.payload}/email_outer_server/`;
        const response = yield call(API.get, {
            endpoint: `${endpoint}`,
            token: credential.data.token,
        });
        yield put(Actions.GetOuterServerMailReceived(response));
    } catch (error) {
        yield put(Actions.GetOuterServerMailFailed(yield error));
    }
}

function* updateOuterServerMail(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const endpoint = `/api/v1/event/${action.payload.shortName}/email_outer_server/`;
        const response = yield call(API.putWithFile, {
            endpoint: `${endpoint}`,
            body: action.payload.params,
            token: credential.data.token,
        });
        yield put(Actions.UpdateOuterServerMailReceived(response));
    } catch (error) {
        yield put(Actions.UpdateOuterServerMailFailed(yield error));
    }
}

function* deleteOuterServerMail(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const endpoint = `/api/v1/event/${action.payload}/email_outer_server/`;
        const response = yield call(API.delete, {
            endpoint: `${endpoint}`,
            token: credential.data.token,
        });
        yield put(Actions.DeleteOuterServerMailReceived(response));
    } catch (error) {
        yield put(Actions.DeleteOuterServerMailFailed(yield error));
    }
}

export default function* outerServerMail() {
    yield all([
        takeEvery('GET_OUTER_SERVER_MAIL_REQUESTED', getOuterServerMail),
        takeEvery('UPDATE_OUTER_SERVER_MAIL_REQUESTED', updateOuterServerMail),
        takeEvery('DELETE_OUTER_SERVER_MAIL_REQUESTED', deleteOuterServerMail),
    ]);
}
